import { List, ShowButton, TextField, useTable } from "@refinedev/antd";
import { Space, Table } from "antd";
import { errorNotification } from "../../../helpers";
import { AppImagePreview } from "../../../components";
import { PartnersType } from "../Lib";
import s from "../../News/News-List/All-News/All-News.module.scss";
import { useNavigation } from "@refinedev/core";
import { PartnersDelete } from "../Partners-Delete/Partners-Delete";
export const PartnersList = ({ leagueId }: { leagueId?: number | null }) => {
  const { push } = useNavigation();

  const { tableProps, searchFormProps } = useTable<PartnersType[]>({
    dataProviderName: "partnersDataProvider",
    resource: "partners",
    syncWithLocation: false,
    meta: { leagueId },
    queryOptions: {
      enabled: true,
    },
    ...errorNotification(),
  });

  const handleNavigateToPartner = (id: string) => {
    push(`/partners/${id}`);
  };

  return (
    <List
      title={false}
      resource={"partners"}
      breadcrumb={false}
      canCreate={false}
      wrapperProps={{ style: { position: "sticky", top: 24 } }}
      headerButtons={false}
    >
      <Table
        {...tableProps}
        scroll={{ x: 1200 }}
        rowKey="id"
        locale={{
          emptyText: <div style={{ margin: 56 }}>Партнеры отсутствуют</div>,
        }}
        showSorterTooltip={false}
        pagination={false}
      >
        <Table.Column<PartnersType>
          dataIndex={""}
          width={300}
          key="bik"
          title={"Иконка"}
          render={(_, record) => (
            <AppImagePreview
              imageURL={record.photoUrl}
              useS3={true}
              sharedStyles={s.imageUrl}
            />
          )}
        />
        <Table.Column<PartnersType>
          dataIndex={""}
          width={300}
          key="wlLogo"
          title={"Иконка для WL"}
          render={(_, record) => (
            <AppImagePreview
              imageURL={record.wlLogo ?? ""}
              useS3={true}
              sharedStyles={s.imageUrl}
            />
          )}
        />
        <Table.Column<PartnersType>
          width={200}
          dataIndex={"name"}
          key="name"
          title="Имя"
          render={(_, record) => <TextField value={record.name} />}
        />
        <Table.Column<PartnersType>
          width={200}
          dataIndex={"ord"}
          key="ord"
          title="Порядок отображения"
        />
        <Table.Column<PartnersType>
          width={200}
          dataIndex={"partnerType"}
          key="partnerType"
          title="Тип партнера"
          render={(_, record) => <TextField value={record.partnerType} />}
        />
        <Table.Column<PartnersType>
          width={200}
          dataIndex={"name"}
          key="name"
          title="Ссылка"
          render={(_, record) => <TextField value={record.link} />}
        />
        <Table.Column<PartnersType>
          width={260}
          dataIndex={"name"}
          fixed={"right"}
          key="name"
          title="Действия"
          render={(_, record) => (
            <Space size={8} direction="vertical" style={{ width: "100%" }}>
              <ShowButton
                onClick={() => handleNavigateToPartner(record.id)}
                size={"small"}
                block
              >
                Смотреть / Редактировать
              </ShowButton>
              <PartnersDelete id={Number(record.id)} name={record.name} />
            </Space>
          )}
        />
      </Table>
    </List>
  );
};
